<div mat-dialog-content >
  <div>
    @if (responseForm) {
      <iframe (load)="exit()" style="width: 100%;height:600px;border:0;" [srcdoc]="responseForm"></iframe>
    }
  </div>
</div>
